import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({
  chartToolTip: {
    padding: '16px 18px',
    background: '#181818',
    color: '#FFFFFF',
    fontSize: 12,
    lineHeight: '14px',
    fontWeight: 400,
    boxShadow: '0px 4px 10px #D4D4D4',
    borderRadius: 3,
  },
})

interface ChartTooltipCommonProps {
  title: string
}

const ChartTooltipCommon = ({ title }: ChartTooltipCommonProps) => {
  const classes = useStyles()

  return <div className={classes.chartToolTip}>{title}</div>
}

export default ChartTooltipCommon
